export default "__VITE_ASSET__DrDs753Q__"